import React from 'react';
import './SuggestionButtons.css';

function SuggestionButtons({ suggestions = [], onSuggestionClick }) {
  if (!suggestions.length) return null;

  return (
    <div className="suggestion-buttons">
      <div className="suggestions-label">Suggested questions:</div>
      <div className="suggestions-list">
        {suggestions.map((suggestion, index) => (
          <button
            key={index}
            className="suggestion-btn"
            onClick={() => onSuggestionClick(suggestion)}
          >
            {suggestion}
          </button>
        ))}
      </div>
    </div>
  );
}

export default SuggestionButtons;